import { useCallback } from 'react';
import { OVERALL_FEEDBACK_ID } from 'react-scale/components/scalers/tasks/ThreadedInteraction/ContributorFeedback/constants';

function doScroll(element: Element) {
  element.scrollIntoView({ behavior: 'smooth', block: 'center' });
}

export const useScrollToOverallFeedback = () => {
  const scrollToOverallFeedback = useCallback(() => {
    const element = document.getElementById(OVERALL_FEEDBACK_ID);

    if (element) {
      doScroll(element);
      return;
    }
  }, []);

  return scrollToOverallFeedback;
};
